import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { useLocation, useNavigate } from "react-router-dom";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { ReactComponent as ArrowDownIcon } from "../../img/ArrowDownCircle.svg";
import { ReactComponent as ListBullet } from "../../img/ListBullet.svg";
import { ReactComponent as MagnificationLogo } from "../../img/magnificationlensicon.svg";
import { ReactComponent as DeleteIcon } from "../../img/plusicon.svg";
import { formatNumber } from "../../numberingformat";
import { instance2 } from "../../utils/axiosInstance";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { ChevronLeft, ChevronRight, Plus } from "lucide-react";
import { toast } from "sonner";
import { Badge } from "src/components/shadcn/badge";
import { Button } from "src/components/shadcn/button";
import { Card, CardContent } from "src/components/shadcn/card";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/shadcn/dialog";
import { Input } from "src/components/shadcn/input";
import { Label } from "src/components/shadcn/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "src/components/shadcn/select";
import { Textarea } from "src/components/shadcn/textarea";
import { useMediaQuery } from "src/lib/hooks";
import { cn } from "src/lib/utils";
import { format } from "date-fns";
import { formatCaption } from "react-day-picker";

export default function MenuMingguan() {
  const userAuthentication = localStorage.getItem("userAuthentication");
  const locationId = parseInt(localStorage.getItem("locationId"), 10); // Convert to integer
  // console.log("locationId", locationId);

  const localDateString = (thedate) => {
    const year = thedate.getFullYear();
    const month = String(thedate.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are 0-based
    const day = String(thedate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const [expandedDay, setExpandedDay] = useState(null); // To store the clicked day for full text view
  const location = useLocation();

  // Extract startDate and endDate from the URL query string
  const queryParams = new URLSearchParams(location.search);
  const kitchen_id = queryParams.get("kitchen_id");
  const startDate = localDateString(new Date(queryParams.get("startDate")));

  // console.log("startDate", startDate);
  const endDate = localDateString(new Date(queryParams.get("endDate")));
  const kitchenIdFromQuery = queryParams.get("kitchen_id");

  const navigate = useNavigate();

  const roleId = parseInt(localStorage.getItem("roleId"), 10);
  const days = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat"];
  const placeholders = ["KARBOHIDRAT", "PROTEIN", "SAYURAN", "BUAH", "MINUMAN"];
  const initialZones = placeholders.map((placeholder, index) => ({
    id: `${index + 1}`,
    content: placeholder,
    item: null,
    allowedCategoryId: index + 1,
  }));

  const [zones, setZones] = useState(
    days.map((day) => ({
      day,
      dropZones: initialZones.map((zone) => ({
        ...zone,
        id: `${day}-${zone.id}`,
      })),
    })),
  );
  const [newlyDroppedZoneIds, setNewlyDroppedZoneIds] = useState([]);
  const [selectedZoneId, setSelectedZoneId] = useState("");
  const [selectedWeekDatesIndex, setSelectedWeekDatesIndex] = useState();
  const [showMenuDialog, setShowMenuDialog] = useState(false);

  const [draggedItem, setDraggedItem] = useState(null);
  const [draggableItems, setDraggableItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [draftData, setDraftData] = useState([]);
  const [purchaseOrder, setPurchaseOrder] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("SEMUA");
  const [categories, setCategories] = useState([]);
  const [user, setUser] = useState("");
  const kitchenid = localStorage?.getItem("kitchenId") || null;
  const [loading, setLoading] = useState(false);
  const [isHolidaySetting, setIsHolidaySetting] = useState(false); // To toggle between button and input
  const [holidayName, setHolidayName] = useState("");
  const [editingHolidayDay, setEditingHolidayDay] = useState(null); // State to track the day being edited
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const [locationKitchen, setlocationKitchen] = useState([]);
  const [selected, setSelected] = useState(kitchenIdFromQuery || "");
  const [showCreateMenuDialog, setShowCreateMenuDialog] = useState(false);
  const [dishCategories, setDishCategories] = useState([]);
  const [newMenuData, setNewMenuData] = useState({
    name: "",
    category_id: "",
    description: "",
    admin_id: localStorage.getItem("UserAuthentication"),
  });

  const fetchDraggableItems = async () => {
    try {
      const response = await instance2.get("dishes");

      const data = response.data.map((item) => ({
        id: item.id,
        category_id: item.category_id,
        category_name: item.category_name,
        recipe_count: item.recipe_count,
        dish_name: item.dish_name,
        description: item.description,
      }));

      setDraggableItems(data);
      setFilteredItems(data);

      const uniqueCategories = [
        "SEMUA",
        ...new Set(data.map((item) => item.category_name)),
      ];
      setCategories(uniqueCategories);
      return data;
    } catch (err) {
      console.error("Error fetching draggable items:", err);
      return [];
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await instance2.get("dish_category");
        const apiCategories = response.data?.data || response.data || [];
        setDishCategories(apiCategories);
      } catch (error) {
        console.error("Error fetching dish categories:", error);
      }
    };

    fetchCategories();
    fetchDraggableItems();
  }, []);

  useEffect(() => {
    // Fetch dropdown options from API
    instance2
      .get(`kitchen/location/${locationId}`)
      .then((response) => {
        setlocationKitchen(response.data); // assuming response.data is an array
      })
      .catch((error) => {
        console.error("Failed to fetch dropdown options:", error);
      });
  }, []);

  const getNextMonday = () => {
    const currentDate = new Date();
    const dayOfWeek = currentDate.getDay();
    const daysUntilNextMonday = dayOfWeek === 0 ? 1 : 8 - dayOfWeek; // Ensure Monday
    currentDate.setDate(currentDate.getDate() + daysUntilNextMonday);
    return currentDate;
  };

  const capitalizeWords = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handleAddNewItem = (query) => {
    // You can show a modal, redirect to a form, or add it directly
    console.log("Adding new item:", query);

    // Example: show modal or update state
    // setShowAddModal(true);
    // setNewItemName(query);
  };

  const handleDropdownChange = (e) => {
    const selectedId = e.target.value;
    setSelected(selectedId);

    // Update the URL without reloading
    navigate(
      `?kitchen_id=${selectedId}&startDate=${startDate}&endDate=${endDate}`,
    );
  };
  // ✅ Initialize selectedDate based on roleId (only runs once at mount)
  const [selectedDate, setSelectedDate] = useState(() =>
    roleId === 2 || roleId === 4 || roleId === 5
      ? queryParams.get("startDate")
        ? new Date(localDateString(new Date(queryParams.get("startDate"))))
        : getNextMonday()
      : new Date(),
  );

const fetchData = async () => {
  setLoading(true);

  const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);

  try {
    const dates = [];
    let current = new Date(startDate);
    while (current <= new Date(endDate)) {
      dates.push(localDateString(new Date(current)));
      current.setDate(current.getDate() + 1);
    }

    // Fetch semua hari paralel
    const draftPromises = dates.map(date =>
      instance2.get(
        `saved_menu_schedule/kitchen/${kitchen_id || kitchenid}/${date}`
      )
    );

    const purchasePromises = dates.map(date =>
      instance2.get(
        `purchase_order/kitchen/${kitchen_id || kitchenid}/${date}`
      )
    );

    const draftResponses = await Promise.all(draftPromises);
    const purchaseResponses = await Promise.all(purchasePromises);

    // Simpan hasilnya per tanggal
    const draftDataByDate = {};
    const purchaseDataByDate = {};

    dates.forEach((date, index) => {
      draftDataByDate[date] =
        draftResponses[index].data.length > 0
          ? draftResponses[index].data[0].id
          : null;

      purchaseDataByDate[date] =
        purchaseResponses[index].data.length > 0
          ? purchaseResponses[index].data[0].id
          : null;
    });

    setDraftData(draftDataByDate);
    setPurchaseOrder(purchaseDataByDate);

    console.log("Draft data:", draftDataByDate["2025-08-19"]);
  } catch (err) {
    console.error("Error fetching data:", err);
  }

  setLoading(false);
};

useEffect(() => {
  fetchData();
}, [roleId, selectedDate, kitchen_id, kitchenid]);



  useEffect(() => {
    const storedUser = localStorage.getItem("userAuthentication");
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  const getWeekStartAndEndDates = (date, roleId) => {
    const current = new Date(date);

    // If roleId is 2, set the date to next Monday instead of the current date
    if (roleId === 2 || roleId === 4 || roleId === 5) {
      const dayOfWeek = current.getDay();
      const daysUntilNextMonday = (8 - dayOfWeek) % 7;
      current.setDate(current.getDate() + daysUntilNextMonday);
    }

    const dayOfWeek = current.getDay(); // Get the day of the week (0 - Sunday, 6 - Saturday)

    // Calculate Monday (start of the week)
    const monday = new Date(current);
    monday.setDate(current.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

    // Calculate Sunday (end of the week)
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    return { startDate: monday, endDate: sunday };
  };

  const getDefaultWeekDates = () => {
    if (roleId === 2 || roleId === 4 || roleId === 5) {
      const today = new Date();
      const startDate = new Date(
        today.setDate(today.getDate() - today.getDay() + 7),
      ); // This week's Monday
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // This week's Sunday
    } else {
      const today = new Date();
      const startDate = new Date(
        today.setDate(today.getDate() - today.getDay() + 1),
      ); // This week's Monday
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // This week's Sunday
    }
    return {
      weekNumber: 1,
      startDate: localDateString(new Date(startDate)),
      endDate: localDateString(new Date(endDate)),
    };
  };

  const [weekDetails, setWeekDetails] = useState(getDefaultWeekDates());
  useEffect(() => {
    const { weekNumber, startDate, endDate } = getWeekDetails(selectedDate);
    setWeekDetails({ weekNumber, startDate, endDate });
  }, [selectedDate]);

  useEffect(() => {
    const { startDate, endDate } = getWeekStartAndEndDates(
      selectedDate,
      roleId,
    );

    const fetchMenuData = async () => {
      try {
        // console.log("response", response)
        console.log(
          "url",
          `menu_schedule/kitchen/${kitchen_id ? kitchen_id : kitchenid}/${localDateString(startDate)}/${localDateString(endDate)}`,
        );

        const response = await instance2.get(
          `menu_schedule/kitchen/${kitchen_id ? kitchen_id : kitchenid}/${localDateString(startDate)}/${localDateString(endDate)}`,
        );
      } catch (err) {
        console.error("Error fetching menu data:", err);
      }
    };

    fetchMenuData();
  }, [selectedDate, kitchen_id, startDate, endDate, roleId]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const query = searchQuery.toLowerCase();
    const category = selectedCategory;

    setFilteredItems(
      draggableItems.filter(
        (item) =>
          (category === "SEMUA" || item.category_name === category) &&
          (item.dish_name.toLowerCase().includes(query) ||
            item.category_name.toLowerCase().includes(query)),
      ),
    );
  }, [searchQuery, selectedCategory, draggableItems]);

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);
    filterItems(searchQuery, category);
  };

  const filterItems = (query, category) => {
    setFilteredItems(
      draggableItems.filter(
        (item) =>
          (category === "SEMUA" || item.category_name === category) &&
          (item.dish_name.toLowerCase().includes(query) ||
            item.category_name.toLowerCase().includes(query)),
      ),
    );
  };

  const handleDragStart = (event, item) => {
    setDraggedItem(item);
    event.dataTransfer.setData("text", item.id);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleChangePack = async (event, kitchenId, date, qty) => {
    const formattedDate = localDateString(new Date(date)); // Format date as YYYY-MM-DD
    const apiEndpoint = `kitchen_pack_date/${kitchenId}/${formattedDate}`; // Use relative path
    const payload = {
      qty: qty,
      admin_id: user,
    };

    try {
      const response = await instance2.post(apiEndpoint, payload); // Use instance2 for the API call
        console.log("Drop saved successfully", response.data);
    } catch (error) {
      console.error("Error saving drop:", error);
      toast.error("Failed to save the qty. Reverting...");
    }
  };

  const getDatesInRange = (start, end) => {
    const dates = [];
    const current = new Date(start);
    while (current <= end && dates.length < 5) {
      dates.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  const mobileHandleClick = async (
    event,
    zoneId,
    date,
    item,
    suppressToast = false,
  ) => {
    if (event) event.preventDefault();

    const targetZone = zones
      .flatMap((day) => day.dropZones)
      .find((zone) => zone.id === zoneId);

    if (targetZone && item) {
      // Check if the category of the dragged item matches the allowed category for the drop zone
      if (targetZone.allowedDay) {
        if (targetZone.allowedCategoryId === item.category_id) {
          // 🔄 Temporarily remove zoneId to retrigger animation
          setNewlyDroppedZoneIds((prev) => prev.filter((id) => id !== zoneId));

          // ✅ Ensure animation is re-triggered after a slight delay
          setTimeout(() => {
            setNewlyDroppedZoneIds((prev) => [...prev, zoneId]);
          }, 10); // 10ms delay to reset animation

          // Temporarily update the UI
          setZones((prevZones) =>
            prevZones.map((day) => ({
              ...day,
              dropZones: day.dropZones.map((zone) =>
                zone.id === zoneId ? { ...zone, item } : zone,
              ),
            })),
          );

          const formattedDate = localDateString(new Date(date)); // Format date as YYYY-MM-DD
          const apiEndpoint = `menu_schedule/${kitchen_id ? kitchen_id : kitchenid}/${formattedDate}`; // Use relative path

          const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);
          const payload = {
            category_id: targetZone.allowedCategoryId,
            dish_id: item.id,
            location_id: locationId,
            admin_id: user,
            qty: zones[0].pack,
            startdate: localDateString(new Date(startDate)),
            enddate: localDateString(new Date(endDate)),
          };

          if (!suppressToast) {
            const rangeFormattedDate = getDatesInRange(startDate, endDate)
              .map((date) => localDateString(date))
              .filter((_, index) => !zones[index].is_holiday);

            const batchApiEndpoints = rangeFormattedDate.map(
              (formattedDate) =>
                `menu_schedule/${kitchen_id ? kitchen_id : kitchenid}/${formattedDate}`,
            );

            toast(`Tambahkan ${item.dish_name} menjadi menu setiap hari?`, {
              id: `addall-prompt-${item.dish_name}`,
              action: (
                <Button
                  size="sm"
                  className="ml-auto"
                  onClick={() => {
                    batchApiEndpoints.map((endpoint) =>
                      instance2.post(endpoint, payload),
                    );
                    toast.dismiss(`addall-prompt-${item.dish_name}`);
                    toast.success(
                      `Berhasil menjadikan ${item.dish_name} sebagai menu setiap hari dalam seminggu!`,
                    );
                    setZones((prevZones) =>
                      prevZones.map((day) => ({
                        ...day,
                        dropZones: day.dropZones.map((zone) =>
                          zone.allowedCategoryId === item.category_id &&
                          zone.allowedDay
                            ? {
                                ...zone,
                                item,
                              }
                            : zone,
                        ),
                      })),
                    );
                  }}
                >
                  Tambahkan
                </Button>
              ),
            });
          }

          try {
            const response = await instance2.post(apiEndpoint, payload);
            console.log("Drop saved successfully", response.data);
          } catch (error) {
            console.error("Error saving drop:", error);
            toast.error("Failed to save the drop. Reverting...");
          }
        } else {
          toast.error(
            `This item cannot be placed here. Allowed category: ${targetZone.allowedCategoryId}`,
          );
        }
      } else {
        toast.error(`This item cannot be placed here. Day is Off.`);
      }
    }
  };

  const handleDrop = async (event, zoneId, date) => {
    event.preventDefault();
    const addAll = false;

    const targetZone = zones
      .flatMap((day) => day.dropZones)
      .find((zone) => zone.id === zoneId);

    if (targetZone && draggedItem && !draftData[localDateString(new Date(date))]) {
      // Check if the category of the dragged item matches the allowed category for the drop zone
      if (targetZone.allowedDay) {
        if (targetZone.allowedCategoryId === draggedItem.category_id) {
          // 🔄 Temporarily remove zoneId to retrigger animation
          setNewlyDroppedZoneIds((prev) => prev.filter((id) => id !== zoneId));

          // ✅ Ensure animation is re-triggered after a slight delay
          setTimeout(() => {
            setNewlyDroppedZoneIds((prev) => [...prev, zoneId]);
          }, 10); // 10ms delay to reset animation

          // Temporarily update the UI
          setZones((prevZones) =>
            prevZones.map((day) => ({
              ...day,
              dropZones: day.dropZones.map((zone) =>
                zone.id === zoneId ? { ...zone, item: draggedItem } : zone,
              ),
            })),
          );

          // API Call
          const formattedDate = localDateString(new Date(date)); // Format date as YYYY-MM-DD
          const apiEndpoint = `menu_schedule/${kitchen_id ? kitchen_id : kitchenid}/${formattedDate}`; // Use relative path

          const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);
          const payload = {
            category_id: targetZone.allowedCategoryId,
            dish_id: draggedItem.id,
            location_id: locationId,
            admin_id: user,
            qty: zones[0].pack,
            startdate: localDateString(new Date(startDate)),
            enddate: localDateString(new Date(endDate)),
          };

          const rangeFormattedDate = getDatesInRange(startDate, endDate)
            .map((date) => localDateString(date))
            .filter((_, index) => !zones[index].is_holiday);

          const batchApiEndpoints = rangeFormattedDate.map(
            (formattedDate) =>
              `menu_schedule/${kitchen_id ? kitchen_id : kitchenid}/${formattedDate}`,
          );

          toast(
            `Tambahkan ${draggedItem.dish_name} menjadi menu setiap hari?`,
            {
              id: `addall-prompt-${draggedItem.dish_name}`,
              action: (
                <Button
                  size="sm"
                  className="ml-auto"
                  onClick={() => {
                    batchApiEndpoints.map((endpoint) =>
                      instance2.post(endpoint, payload),
                    );
                    toast.dismiss(`addall-prompt-${draggedItem.dish_name}`);
                    toast.success(
                      `Berhasil menjadikan ${draggedItem.dish_name} sebagai menu setiap hari dalam seminggu!`,
                    );
                    setZones((prevZones) =>
                      prevZones.map((day) => ({
                        ...day,
                        dropZones: day.dropZones.map((zone) =>
                          zone.allowedCategoryId === draggedItem.category_id &&
                          zone.allowedDay
                            ? {
                                ...zone,
                                item: draggedItem,
                              }
                            : zone,
                        ),
                      })),
                    );
                  }}
                >
                  Tambahkan
                </Button>
              ),
            },
          );

          try {
            const response = await instance2.post(apiEndpoint, payload);
            console.log("Drop saved successfully", response.data);
          } catch (error) {
            console.error("Error saving drop:", error);
            toast.error("Failed to save the drop. Reverting...");
          }
        } else {
          toast.error(
            `This item cannot be placed here. Allowed category: ${targetZone.allowedCategoryId}`,
          );
        }
      } else {
        toast.error(`This item cannot be placed here. Day is Off.`);
      }
    } else if (draftData[localDateString(new Date(date))]) {
      toast.error(
        `Order untuk tanggal ${localDateString(new Date(date))} sudah disiapkan. Silakan hapus menu terlebih dahulu sebelum menambahkan.`,
      );
    }
  };

  const getWeekDates = (date) => {
    const startDate = new Date(date);
    const dayOffset = startDate.getDay() === 0 ? 6 : startDate.getDay() - 1;
    startDate.setDate(startDate.getDate() - dayOffset);
    return Array.from({ length: 5 }, (_, i) => {
      const newDate = new Date(startDate);
      newDate.setDate(startDate.getDate() + i);
      return newDate;
    });
  };

  const weekDates = getWeekDates(selectedDate);

  const getWeekDetails = (date) => {
    // console.log("Input date:", date);

    // Ensure the input is converted to a Date object if it's not already
    const currentDate = new Date(date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are 0-based
    const day = String(date.getDate()).padStart(2, "0");

    //console.log("currentDate", currentDate)
    const localDate = `${year}-${month}-${day}`;
    //console.log("Formatted Local Date:", localDate);

    if (isNaN(currentDate)) {
      console.error("Invalid date provided:", date);
      return {
        weekNumber: null,
        monthName: null,
        startDate: null,
        endDate: null,
      };
    }

    //console.log("Parsed date:", currentDate);

    const startOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1,
    ); // Start of the month
    const dayOfWeek = currentDate.getDay();

    // Calculate the start of the week (Monday)
    const startDate = new Date(currentDate);
    const diff = startDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Monday
    startDate.setDate(diff);

    //console.log("Calculated startDate:", startDate);

    // Calculate the end of the week (Friday)
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6); // Friday is 4 days after Monday
    //console.log("Calculated endDate:", endDate);

    // Calculate the week number of the month
    const daysSinceStartOfMonth = Math.floor(
      (startDate - startOfMonth) / (1000 * 60 * 60 * 24),
    );
    const weekNumber = Math.ceil((daysSinceStartOfMonth + 1) / 7);
    //console.log("Week number:", weekNumber);

    // Month Names
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const monthName = monthNames[startDate.getMonth()]; // Use startDate for the month name
    //console.log("Month name:", monthName);

    return {
      weekNumber,
      monthName,
      startDate: localDateString(startDate),
      endDate: localDateString(endDate),
    };
  };

  // Update week details when the selected date changes
  useEffect(() => {
    const { weekNumber, startDate, endDate } = getWeekDetails(selectedDate);
    // console.log("selected",selectedDate)
    setWeekDetails({ weekNumber, startDate, endDate });
  }, [selectedDate]);

  const [isOpen, setIsOpen] = useState(false);
  const CustomInput = React.forwardRef(({ onClick, isOpen }, ref) => (
    <button
      className={`flex flex-row items-center justify-between w-full px-4 py-2 border rounded-[15px] gap-2 ${kitchen_id ? "bg-gray-200 cursor-not-allowed" : "bg-white"}`}
      onClick={onClick}
      ref={ref}
      type="button"
      disabled={kitchen_id}
    >
      <div className="flex w-full lg:flex-row flex-col items-center gap-2">
        <span className="font-semibold">
          {`W${weekDetails.weekNumber} ${new Date(
            weekDetails.startDate,
          ).toLocaleDateString("id-ID", {
            month: "long", // For full month name in Indonesian
          })}`}
        </span>
        <span className="text-sm sm:text-base">
          <span className="lg:inline hidden">(</span>
          {`${new Date(weekDetails.startDate).toLocaleDateString("id-ID", {
            year: "numeric",
            month: "long", // For full month name in Indonesian
            day: "2-digit",
          })} - ${new Date(weekDetails.endDate).toLocaleDateString("id-ID", {
            year: "numeric",
            month: "long", // For full month name in Indonesian
            day: "2-digit",
          })}`}
          <span className="lg:inline hidden">)</span>
        </span>
      </div>

      {/* Arrow Icon */}

      <div
        className={`text-black font-semibold transform transition-transform ${isOpen ? "rotate-180" : "rotate-0"}`}
      >
        ▼
      </div>
    </button>
  ));

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const handleBuatPesanan = async () => {
    const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);

    // console.log('User Authentication:', userAuthentication);
    // console.log('Location ID (as integer):', locationId);

    // try {
    //   const requestBody = {
    //     location_id: locationId,
    //     startdate: localDateString(new Date(startDate)),
    //     enddate: localDateString(new Date(endDate)),
    //     admin_id: userAuthentication,
    //   };

    //   const response = await instance2.post(
    //     "/ingredient_location",
    //     requestBody,
    //   );
    //   console.log("/ingredient_location", requestBody);
    //   if (response.status === "OK") {
    //     console.log("Success:", response.data);
    //     setPopupMessage("Data telah tersimpan");
    //     setIsPopupVisible(true); // Show the popup

    // console.log(`/daftarpesanan?startDate=${localDateString(new Date(startDate))}&endDate=${localDateString(new Date(endDate))}`)
    navigate(
      `/daftarpesanan?startDate=${localDateString(new Date(startDate))}&endDate=${localDateString(new Date(endDate))}`,
    );
    //   } else {
    //     console.error("Error:", response.data);
    //     setPopupMessage("Gagal menyimpan data");
    //     setIsPopupVisible(true); // Show the popup
    //   }
    // } catch (error) {
    //   console.error("Network Error:", error);
    //   setPopupMessage("An error occurred while submitting the data.");
    //   setIsPopupVisible(true); // Show the popup
    // }
  };
const handleSimpanMenu = async (date) => {
  let startDate, endDate;

  // Kalau date string, jadikan start & end sama
  if (typeof date === "string") {
    startDate = date;
    endDate = date;
  } 
  // Kalau date object { startDate, endDate }
  else if (typeof date === "object" && date !== null) {
    startDate = date.startDate;
    endDate = date.endDate;
  } else {
    console.error("Format date tidak valid:", date);
    return;
  }

  try {
    const requestBody = {
      location_id: locationId,
      startdate: startDate,
      enddate: endDate,
      admin_id: userAuthentication,
    };

    const kitchenPath = `/order_draft_header/kitchen/${kitchen_id || kitchenid}`;

    const response = await instance2.post(kitchenPath, requestBody);
    const responseBuatPesanan = await instance2.post("/ingredient_location", requestBody);

    const isSuccess =
      (response.status === "OK" || response.data?.status === "OK" || response.status === 200) &&
      (responseBuatPesanan.status === "OK" || responseBuatPesanan.data?.status === "OK" || responseBuatPesanan.status === 200);

    if (isSuccess) {
      console.log("Success:", response.data);
      setPopupMessage("Data telah tersimpan");
      setIsPopupVisible(true);
      fetchData()
      // setDraftData(true);
    } else {
      console.error("Errornya:", response.data, response.data.status, responseBuatPesanan.data.status, response.status, responseBuatPesanan.status);
      setPopupMessage("Gagal menyimpan data");
      setIsPopupVisible(true);
    }
  } catch (error) {
      if (error.response) {
    console.error("API Error:", error.response.data);
  } else {
    console.error("Network Error:", error);
  }
    setPopupMessage("Terjadi kesalahan saat menyimpan data.");
    setIsPopupVisible(true);
  }
};


  const [menuData, setMenuData] = useState([]);
  const [packData, setPackData] = useState([]);
  const [holidayData, setHolidayData] = useState([]);

  useEffect(() => {
    if (!selectedDate) return;

    const fetchAllData = async () => {
      setLoading(true);

      try {
        const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);
        // console.log ("a",kitchenid,"b", kitchen_id)
        const [menuResponse, packResponse, holidayResponses] =
          await Promise.all([
            instance2.get(
              `menu_schedule/kitchen/${kitchen_id ? kitchen_id : kitchenid}/${localDateString(new Date(startDate))}/${localDateString(new Date(endDate))}`,
            ),
            instance2.get(
              roleId === 3 || roleId === 5
                ? `kitchen_pack_date/kitchen/${kitchen_id ? kitchen_id : kitchenid}/${localDateString(new Date(startDate))}/${localDateString(new Date(endDate))}`
                : `kitchen_pack_date/location/${locationId}/${localDateString(new Date(startDate))}/${localDateString(new Date(endDate))}`,
            ),
            Promise.all(
              weekDates.map((date) =>
                instance2.get(
                  roleId === 3 || roleId === 5
                    ? `/holidays/kitchen/${kitchen_id ? kitchen_id : kitchenid}/${localDateString(new Date(date))}`
                    : `/holidays/location/${locationId}/${localDateString(new Date(date))}`,
                ),
              ),
            ),
          ]);

        // Process responses
        setMenuData(menuResponse.status === "OK" ? menuResponse.data : []);
        setPackData(packResponse.status === "OK" ? packResponse.data : []);
        // console.log("pack", packData, packResponse.data);

        const processedHolidays = holidayResponses
          .map((response) => {
            if (response.status === "OK") {
              return {
                date: localDateString(new Date(response.data[0].date)),
                is_holiday: response.data[0].is_holiday,
                holiday_name: response.data[0].name,
              };
            }
            return null;
          })
          .filter(Boolean);

        setHolidayData(processedHolidays);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [selectedDate, kitchen_id, locationId]); // ✅ Ensure `selectedDate` is a dependency

  useEffect(() => {
    // if (!menuData.length || !packData.length || !holidayData.length) {
    //   // console.warn("Data is still loading, skipping zones update...");
    //   return;
    // }

    const updatedZones = days.map((day, index) => {
      const dayDate = localDateString(weekDates[index]);

      const matchingPackData = packData.find((item) =>
        localDateString(new Date(item.date)).startsWith(dayDate),
      );

      const dayMenuData = menuData.find((item) =>
        localDateString(new Date(item.date)).startsWith(dayDate),
      );

      return {
        day,
        is_holiday: holidayData[index]?.is_holiday || false,
        holiday_name: holidayData[index]?.holiday_name || "",
        pack: matchingPackData ? matchingPackData.qty : "",
        dropZones: initialZones.map((zone, zIndex) => ({
          ...zone,
          id: `${day}-${zone.id}`,
          item:
            dayMenuData && dayMenuData[placeholders[zIndex]] !== null
              ? { dish_name: dayMenuData[placeholders[zIndex]] }
              : null,
          qty: day.pack,
          allowedDay: !holidayData[index]?.is_holiday,
        })),
      };
    });

    setZones(updatedZones);
  }, [selectedDate, menuData, packData, holidayData]); // ✅ Make sure `selectedDate` is here!

  // ✅ Once all data is available, update `zones`
  useEffect(() => {
    if (
      menuData.length === 0 ||
      packData.length === 0 ||
      holidayData.length === 0
    ) {
      return; // Avoid updating if data is still loading
    }

    const updatedZones = days.map((day, index) => {
      const dayDate = localDateString(weekDates[index]);

      // Find matching data
      const matchingPackData = packData.find((item) =>
        localDateString(new Date(item.date)).startsWith(dayDate),
      );

      const dayMenuData = menuData.find((item) =>
        localDateString(new Date(item.date)).startsWith(dayDate),
      );

      return {
        day,
        is_holiday: holidayData[index]?.is_holiday || false,
        holiday_name: holidayData[index]?.holiday_name || "",
        pack: matchingPackData ? matchingPackData.qty : packData[index].qty,
        dropZones: initialZones.map((zone, zIndex) => ({
          ...zone,
          id: `${day}-${zone.id}`,
          item:
            dayMenuData && dayMenuData[placeholders[zIndex]] !== null
              ? { dish_name: dayMenuData[placeholders[zIndex]] }
              : null,
          qty: day.pack,
          allowedDay: !holidayData[index]?.is_holiday,
        })),
      };
    });

    setZones(updatedZones);
  }, [menuData, packData, holidayData]); // ✅ Runs when all data is fully loaded

  const handlePackChange = async (date, newPackValue) => {
    if (!date || !kitchenid) {
      console.error("Date or kitchen ID is missing. Skipping API call.");
      return;
    }

    try {
      const payload = {
        date: date, // ✅ Correct: Using actual date (YYYY-MM-DD)
        qty: newPackValue, // ✅ Correct: Sending the updated quantity
      };

      const response = await instance2.post(
        `/kitchen_pack_date/kitchen/${kitchenid}`,
        payload,
      );

      if (response.status === "OK") {
        // console.log("Pack value updated successfully", response.data);
      } else {
        console.error("Failed to update pack value", response.data);
      }
    } catch (error) {
      console.error("Error updating pack value:", error);
    }
  };

  const handleSchedule = async (date) => {
    navigate(`/jadwalcustomer?date=${localDateString(new Date(date))}`);
  };

  useEffect(() => {
    setNewlyDroppedZoneIds([]); // Reset animation state when date changes
  }, [selectedDate]); // Runs every time the date is changed

  const isDraftDisabled = zones.some(
    (day) =>
      !day.is_holiday &&
      day.dropZones.some(
        (zone) => !zone.item && zone.content !== "MINUMAN", // allow MINUMAN to be empty
      ),
  ); // Checks if there's any empty dropZone on a not-holiday day

// disable if the *day* has any empty non-MINUMAN slot and it's not a holiday
const isDayDraftDisabled = (day) =>
  !day.is_holiday &&
  day.dropZones.some((zone) => !zone.item && zone.content !== "MINUMAN");


  const handleSetHoliday = (dayName) => {
    // Cancel previous holiday input and reset previous day
    if (editingHolidayDay && editingHolidayDay !== dayName) {
      setZones((prevZones) =>
        prevZones.map((day) =>
          day.day === editingHolidayDay
            ? {
                ...day,
                is_holiday: false, // Revert previous day to not holiday
                holidayName: "", // Clear previous holiday name
                dropZones: day.dropZones.map((zone) => ({
                  ...zone,
                  allowedDay: true, // Re-enable drop zones
                })),
              }
            : day,
        ),
      );
    }

    // Mark the current day as holiday without hiding the zone content yet
    setZones((prevZones) =>
      prevZones.map((day) =>
        day.day === dayName
          ? {
              ...day,
              is_holiday: true,
              dropZones: day.dropZones.map((zone) => ({
                ...zone,
                allowedDay: false, // Disable drop zones when marking as holiday
              })),
            }
          : day,
      ),
    );

    setEditingHolidayDay(dayName); // Set this day as the one being edited
  };

  const handleHolidayNameSubmit = (dayName, date, holidayName) => {
    setZones((prevZones) =>
      prevZones.map((day) =>
        day.day === dayName
          ? {
              ...day,
              holidayName: holidayName, // Store the holiday name
              dropZones: day.dropZones.map((zone) => ({
                ...zone,
                allowedDay: false, // Disable drop zones permanently when holiday is set
              })),
            }
          : day,
      ),
    );
    setEditingHolidayDay(null); // Reset after submission

    let holidayScope;
    const location_id = locationId;
    const kitchen_id = kitchenid;
    roleId === 2 || roleId === 4 || roleId === 5
      ? (holidayScope = "location")
      : (holidayScope = "kitchen");
    const payload = {
      date: localDateString(new Date(date)),
      name: holidayName,
      description: "",
      admin_id: user,
      scope: holidayScope,
      location_id: location_id,
      kitchen_id: kitchen_id,
    };
    const fetchHoliday = async () => {
      try {
        const response = await instance2.post(`holidays`, payload); // Use instance2 for the API call
        const data = response.data;
      } catch (err) {
        console.error("Error fetching draft items:", err);
      }
      console.log("dayName", dayName);
    };
    fetchHoliday(selectedDate);
  };

  const handleCancelHolidayName = (dayName) => {
    setHolidayName(""); // Clear the holiday name input
    setEditingHolidayDay(null); // Revert the state, removing the edit mode

    // Don't modify the zone content. Just revert the holiday flag.
    setZones((prevZones) =>
      prevZones.map((day) =>
        day.day === dayName
          ? {
              ...day,
              is_holiday: false, // Cancel the "set as holiday" action
              holidayName: "", // Clear any holiday name if canceled
              dropZones: day.dropZones.map((zone) => ({
                ...zone,
                allowedDay: true, // Re-enable drop zones
              })),
            }
          : day,
      ),
    );
  };

  const handleCreateNewMenu = async (menuData, zoneId = null, date = null) => {
    if (!menuData.name || !menuData.category_id) {
      toast.error("Nama menu dan kategori harus diisi.");
      return;
    }
    try {
      const createResponse = await instance2.post("dishes", menuData);
      const newDishResponse = Array.isArray(createResponse.data)
        ? createResponse.data[0]
        : createResponse.data;

      toast.success(`Menu "${menuData.name}" berhasil dibuat!`);

      const allDishes = await fetchDraggableItems();
      const newDish = allDishes.find((d) => d.id === newDishResponse.id);

      if (zoneId && date && newDish) {
        await mobileHandleClick(null, zoneId, date, newDish, true);
        toast.success(`"${newDish.dish_name}" telah ditambahkan ke jadwal.`);
      }

      setShowCreateMenuDialog(false);
      setShowMenuDialog(false);
      setSearchQuery("");
      setNewMenuData({
        name: "",
        category_id: "",
        description: "",
        admin_id: localStorage.getItem("UserAuthentication"),
      });
    } catch (error) {
      console.error("Error creating new menu:", error);
      toast.error("Gagal membuat menu baru.");
    }
  };

  const handleLihatPesanan = async () => {
    navigate(`/draftOrder?startDate=${format(selectedDate, "yyyy-MM-dd")}`);
  };

  const allDaysHoliday = zones.every((day) => day.is_holiday);

  const searchResult = filteredItems;
  const suggestion =
    searchResult.length === 0 && searchQuery && selectedCategory !== "SEMUA"
      ? draggableItems.find(
          (item) =>
            item.dish_name.toLowerCase() === searchQuery.toLowerCase() &&
            item.category_name !== selectedCategory,
        )
      : null;

  // const searchResult = filteredItems.filter((item) => item.recipe_count > 0);
  // Compute the longest name length in characters
  const longestNameLength = locationKitchen.reduce(
    (max, option) => Math.max(max, option.name.length),
    0,
  );

const [confirmOpen, setConfirmOpen] = useState(false);
const [toDelete, setToDelete] = useState(null); 
// shape: { zoneId, date, dishName, category }

function openConfirm(zoneId, date, pack, dishName,zonePack, e) {
  e.stopPropagation();
  setToDelete({
    zoneId,
    date,
    pack,       // 👈 day.pack
    dishName,
    zonePack,
  });
  setConfirmOpen(true);
}

async function handleConfirmDelete() {
  if (!toDelete) return;

  try {
    const payload = {
      kitchen_id: kitchenid, // or kitchenId from props/context
      date: toDelete.date,
      zone_id: toDelete.zoneId,
      pack: toDelete.pack,
    };

    console.log("Deleting with payload:", payload);
    console.log("Deleting with payload:", zones);

    const res = await instance2.delete(`/menu_schedule/${kitchenid}/${toDelete.zoneId}`, payload);
    // 👆 axios delete must pass payload under { data }

    if (res.status >= 200 && res.status < 300) {
      toast.success("Data berhasil dihapus!");
      setConfirmOpen(false);
      setToDelete(null);
      fetchData(); // 
    } else {
      toast.error("Gagal menghapus data");
    }
  } catch (err) {
    console.error(err);
    toast.error(err.response?.data?.message || "Terjadi kesalahan");
  }
}



  return (
    <div className="flex w-full h-full">
      {/* Popup Modal */}
      <Dialog
        open={isPopupVisible}
        onOpenChange={(open) => setIsPopupVisible(open)}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Pemberitahuan</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-justify">{popupMessage}</p>
          <DialogFooter className="sm:justify-end">
            <DialogClose asChild>
              <Button type="button">Tutup</Button>
            </DialogClose>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <Dialog
        open={showCreateMenuDialog}
        onOpenChange={(open) => {
          setShowCreateMenuDialog(open);
          if (!open) {
            setNewMenuData({
              name: "",
              category_id: "",
              description: "",
              admin_id: localStorage.getItem("UserAuthentication"),
            });
          }
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Buat Menu Baru</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <Input
              value={newMenuData.name}
              onChange={(e) =>
                setNewMenuData({ ...newMenuData, name: e.target.value })
              }
              placeholder="Nama Menu"
            />
            <Select
              value={newMenuData.category_id}
              onValueChange={(value) =>
                setNewMenuData({ ...newMenuData, category_id: value })
              }
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Kategori" className="capitalize" />
              </SelectTrigger>
              <SelectContent>
                {dishCategories.map((category) => (
                  <SelectItem
                    key={category.id}
                    value={category.id.toString()}
                    className="capitalize"
                  >
                    {category.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Textarea
              value={newMenuData.description}
              onChange={(e) =>
                setNewMenuData({ ...newMenuData, description: e.target.value })
              }
              placeholder="Deskripsi"
            />
          </div>
          <DialogFooter>
            <Button
              className="w-full"
              onClick={() => handleCreateNewMenu(newMenuData)}
            >
              Buat
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      {/* Mobile Menu Dialog */}
      <Dialog
        open={showMenuDialog}
        onOpenChange={(open) => {
          setShowMenuDialog(open);
          if (!open) {
            setSearchQuery("");
            setSelectedCategory("SEMUA");
            setDraggedItem(null);
          }
        }}
      >
        <DialogContent onOpenAutoFocus={(e) => e.preventDefault()}>
          <DialogHeader className="space-y-4">
            <DialogTitle>Pilih Menu</DialogTitle>
            <DialogDescription>
              <Input
                value={searchQuery}
                onChange={handleSearch}
                placeholder="Cari Menu"
              />
            </DialogDescription>
          </DialogHeader>
          <div className="overflow-y-auto h-full flex flex-col max-h-[40vh] gap-2">
            {searchResult.length > 0 ? (
              searchResult.map((item) => (
                <Card
                  key={item.id}
                  id={item.id}
                  className="flex flex-col gap-1 p-4 hover:shadow-md hover:cursor-pointer"
                  onClick={(e) => {
                    mobileHandleClick(
                      e,
                      selectedZoneId,
                      selectedWeekDatesIndex,
                      item,
                    );
                    setSearchQuery("");
                    setSelectedCategory("SEMUA");
                    filterItems("", "SEMUA");
                    setDraggedItem(null);
                    setShowMenuDialog(false);
                  }}
                >
                  <span className="font-semibold">{item.dish_name}</span>
                  <span className="text-sm">{item.category_name}</span>
                </Card>
              ))
            ) : suggestion ? (
              <Card className="flex flex-col gap-4 p-4 text-center">
                <div className="rounded-full p-4 bg-gray-100 w-fit mx-auto">
                  <MagnificationLogo className="size-6 text-gray-500" />
                </div>
                <div className="flex flex-col gap-2 justify-center items-center text-pretty">
                  <span className="font-medium">
                    Menu "{searchQuery}" tidak ditemukan di kategori ini.
                  </span>
                  <span className="text-sm text-gray-500">
                    Namun, menu ini ditemukan di kategori{" "}
                    <strong>{suggestion.category_name}</strong>.
                  </span>
                </div>
                <div className="flex flex-col gap-2">
                  <Button
                    variant="outline"
                    onClick={() => {
                      setShowMenuDialog(false);
                    }}
                    className="whitespace-normal break-words"
                  >
                    Lihat di kategori {suggestion.category_name}
                  </Button>
                  <Button
                    onClick={() => {
                      const category = dishCategories.find(
                        (c) => c.name === selectedCategory,
                      );
                      if (category) {
                        const newMenuPayload = {
                          name: searchQuery,
                          category_id: category.id,
                          description: "",
                          admin_id: user,
                        };
                        handleCreateNewMenu(
                          newMenuPayload,
                          selectedZoneId,
                          selectedWeekDatesIndex,
                        );
                      } else {
                        toast.error(
                          "Kategori tidak valid, tidak bisa membuat menu.",
                        );
                      }
                    }}
                  >
                    Buat dan tambah menu
                  </Button>
                </div>
              </Card>
            ) : (
              <Card className="flex flex-col gap-4 p-4">
                <div className="flex flex-col gap-4 justify-center items-center p-4">
                  <div className="rounded-full p-4 bg-gray-100 w-fit">
                    <MagnificationLogo className="size-6 text-gray-500" />
                  </div>
                  <div className="flex flex-col gap-2 justify-center items-center text-center">
                    <span className="font-medium">
                      Menu "{searchQuery}" tidak ditemukan
                    </span>
                    <span className="text-sm text-gray-500">
                      Tidak ada menu yang cocok dengan pencarian Anda. Buat menu
                      baru atau coba kata kunci lain.
                    </span>
                  </div>
                </div>
                <Button
                  onClick={() => {
                    const category = dishCategories.find(
                      (c) => c.name === selectedCategory,
                    );
                    if (category) {
                      const newMenuPayload = {
                        name: searchQuery,
                        category_id: category.id,
                        description: "",
                        admin_id: user,
                      };
                      handleCreateNewMenu(
                        newMenuPayload,
                        selectedZoneId,
                        selectedWeekDatesIndex,
                      );
                    } else {
                      toast.error(
                        "Kategori tidak valid, tidak bisa membuat menu.",
                      );
                    }
                  }}
                >
                  Buat dan tambah menu
                </Button>
              </Card>
            )}
          </div>
        </DialogContent>
      </Dialog>
      {loading ? (
        <li className="px-4 py-8 flex justify-center">
          {/* Loading Spinner */}
          <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
        </li>
      ) : (
        <div className="flex-1 p-5 h-full overflow-x-hidden">
          <div className="flex flex-col lg:flex-row mb-4 gap-4 items-center justify-between">
            {/* <div className="flex flex-row mb-0"> */}
            <div className="flex flex-col">
              <h1 className="text-2xl font-semibold">Menu Mingguan</h1>
              {roleId === 4 && (
                <div className="mt-4">
                  <a className="pe-4">Pilih Dapur:</a>
                  <select
                    className="px-2 py-4 border border-gray-300 rounded-[25px] outline-none border-none text-xxs md:text-xxs lg:text-base "
                    style={{
                      width: `${longestNameLength + 3}ch`, // add a small buffer so text doesn't get cut off
                    }}
                    value={selected}
                    onChange={handleDropdownChange}
                  >
                    <option value="" disabled>
                      Pilih Dapur
                    </option>
                    {locationKitchen.map((option, index) => (
                      <option key={index} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
            {/* STYLING DATEPICKER DI CUSTOMINPUT */}
            <div className="flex lg:w-auto w-full flex-col lg:flex-row gap-4 items-center">
              <div className="text-gray-700 lg:w-1/3">Pilih Minggu</div>
              {/* <div className="relative w-full lg:w-auto [&_.react-datepicker-wrapper]:w-full [&_.react-datepicker-wrapper]:lg:w-auto"> */}
              <div className="relative z-5 lg:w-full [&_.react-datepicker-wrapper]:w-full [&_.react-datepicker-wrapper]:lg:w-auto">
                {" "}
                {/* Add relative positioning to isolate the DatePicker */}
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat="yyyy-MM-dd"
                  filterDate={(date) => {
                    const day = date.getDay();
                    return day !== 0 && day !== 6;
                  }}
                  onCalendarOpen={() => setIsOpen(true)}
                  onCalendarClose={() => setIsOpen(false)}
                  customInput={<CustomInput isOpen={isOpen} />}
                />
              </div>
              {/* <Badge
                className="flex items-center gap-8 bg-white w-full justify-between py-2 px-4"
                variant="outline"
              >
                <span className="text-sm font-normal">Status Order</span>
                <Badge
                  variant="outline"
                  className={cn(
                    "flex items-center gap-2 bg-white rounded-[0.5rem]",
                    Boolean(draftData && purchaseOrder) &&
                      "bg-blue-600/10 border-blue-600/40",
                    Boolean(draftData && !purchaseOrder) &&
                      "bg-green-700/10 border-green-700/40",
                    Boolean(!draftData) &&
                      "bg-merah-hover/10 border-merah-hover/40",
                  )}
                >
                  <div
                    className={cn(
                      "rounded-full size-2",
                      Boolean(draftData && purchaseOrder) && "bg-blue-600",
                      Boolean(draftData && !purchaseOrder) && "bg-green-700",
                      Boolean(!draftData) && "bg-merah-hover",
                    )}
                  />
                  <span className="font-normal">
                    {draftData
                      ? purchaseOrder
                        ? "Sudah Beli"
                        : "Sudah Draft PO"
                      : "Belum Disimpan"}
                  </span>
                </Badge>
              </Badge> */}
            </div>
          </div>

          {/* Mobile Zones */}
          <div className="grid relative h-full">
            <Button
              variant="outline"
              size="icon"
              className="lg:hidden absolute top-1/2 left-2 z-[2] -translate-x-1/2 swiper-prev my-auto"
            >
              <ChevronLeft size={16} />
            </Button>
            <Swiper
              spaceBetween={50}
              slidesPerView={1}
              loop={isDesktop ? false : true}
              pagination={{
                clickable: true,
                renderBullet: (index, className) =>
                  `<span class="!size-6 !text-sm !rounded-full !aspect-square !bg-white !border !border-gray-300 ${className}">${index + 1}</span>`,
              }}
              navigation={{ nextEl: ".swiper-next", prevEl: ".swiper-prev" }}
              modules={[Pagination, Navigation]}
              className="max-w-full [&_.swiper-pagination]:w-fit [&_.swiper-pagination]:text-balance [&_.swiper-pagination]:space-y-2 [&_.swiper-pagination]:space-x-2 [&_.swiper-pagination]:lg:hidden [&_.swiper-slide]:mb-16 [&_.swiper-slide]:lg:mb-0"
            >
              {zones.map((day, index) => (
                <SwiperSlide key={day.day}>
                  <div
                    className={`flex-col lg:hidden bg-[#F1F2F3] gap-4 items-center ${editingHolidayDay === day.day ? "w-full" : "w-full lg:w-1/5"}`}
                  >
                    <Card
                      className={cn(
                        "mb-4",
                        day.is_holiday
                          ? "bg-primary"
                          : "bg-[#FFA101]/15 border-[#FFA101]/25",
                      )}
                    >
                      <CardContent className="p-6 space-y-1">
                        <h2
                          className={cn(
                            "text-2xl font-semibold text-primary-foreground",
                            !day.is_holiday && "text-foreground",
                          )}
                        >
                          {day.day}
                        </h2>
                        <div className="flex items-center gap-x-2 gap-y-4 flex-wrap justify-between text-sm">
                          <p
                            className={
                              day.is_holiday
                                ? "text-primary-foreground"
                                : "text-gray-600"
                            }
                          >
                            {weekDates[index].toLocaleDateString("id-ID", {
                              day: "2-digit",
                              month: "long",
                              year: "numeric",
                            })}
                          </p>
                          <div
                            onClick={() =>
                              setExpandedDay(
                                expandedDay === day.day ? null : day.day,
                              )
                            }
                            className={cn(
                              "flex items-center gap-2",
                              expandedDay === day.day
                                ? "overflow-visible text-wrap"
                                : "truncate overflow-hidden",
                              day.is_holiday
                                ? "text-primary-foreground"
                                : "text-gray-600",
                            )}
                          >
                            {day.is_holiday ? day.holiday_name || "Libur" : ""}
                            {!day.is_holiday ? (
                              roleId === 3 || roleId === 5 ? (
                                <input
                                  style={{
                                    width: `${"30 DESEMBER 2099".length}ch`,
                                  }}
                                  value={formatNumber(day.pack) || ""}
                                  placeholder=" "
                                  className={`flex-1 bg-transparent outline-none rounded-lg text-black text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-sm text-center flex-grow 
                                    ${roleId !== 3 ? "border-none" : draftData[localDateString(weekDates[index])] ? "border-solid border-black bg-green-100" : "border-solid border-black bg-white"}`}
                                  onChange={(e) => {
                                    //  const newPackValue = formatNumber(e.target.value);
                                    const rawValue = e.target.value.replace(
                                      /\D/g,
                                      "",
                                    );

                                    setZones((prevZones) =>
                                      prevZones.map((zone) =>
                                        zone.day === day.day
                                          ? { ...zone, pack: rawValue }
                                          : zone,
                                      ),
                                    );
                                  }}
                                  disabled={roleId !== 3 || draftData[localDateString(weekDates[index])]}
                                />
                              ) : (
                                formatNumber(day.pack) || ""
                              )
                            ) : (
                              ""
                            )}
                            {!day.is_holiday ? <span>Porsi</span> : ""}

                            {/* Save Button */}
                            {/* {(roleId === 3 || roleId === 5) &&
                            !day.is_holiday &&
                            ! draftData[localDateString(weekDates[index])] ? (
                              <button
                                onClick={() =>
                                  handlePackChange(
                                    localDateString(weekDates[index]),
                                    day.pack,
                                  )
                                }
                                disabled={
                                  !day.pack || day.pack === "0" ||  draftData[localDateString(weekDates[index])]
                                } // Corrected condition
                                className={`rounded-lg  bg-transparent text-red-600 font-medium transition ${
                                  loading
                                    ? "bg-gray-400 cursor-not-allowed"
                                    : !day.pack || day.pack === "0"
                                      ? "bg-gray-300 cursor-not-allowed"
                                      : "hover:text-green-600"
                                }`}
                              >
                                <span title="Simpan">
                                  <ArrowDownIcon className="w-8 h-8" />
                                </span>
                              </button>
                            ) : (
                              ""
                            )} */}

                          </div>
                            {(roleId === 3 || roleId === 5) &&
                            !day.is_holiday &&
                            ! draftData[localDateString(weekDates[index])] ? (
                              <button
                                onClick={() =>
                                  handleSchedule(
                                    localDateString(weekDates[index]),
                                    day.pack,
                                  )
                                }
                                disabled={
                                  !day.pack || day.pack === "0" ||  draftData[localDateString(weekDates[index])]
                                } // Corrected condition
                                className={` text-red-600 font-medium transition ${
                                  loading
                                    ? "bg-gray-400 cursor-not-allowed"
                                    : !day.pack || day.pack === "0"
                                      ? "bg-gray-300 cursor-not-allowed"
                                      : "hover:text-green-600"
                                }`}
                              >
                                <span className="flex flex-row items-center gap-2" title="Edit">
                                  <ListBullet className="w-8 h-8" />
                                  <p>Rencana Produksi</p>
                                </span>
                              </button>
                            ) : (
                              ""
                            )}
                        </div>
                      </CardContent>
                    </Card>

                    {/* "Set as Holiday" Button */}
                    {! draftData[localDateString(weekDates[index])] ? (
                      !purchaseOrder[localDateString(weekDates[index])]  ? (
                        <Dialog>
                          <DialogTrigger asChild>
                            <Button
                              className="w-full text-center mb-2"
                              disabled={day.is_holiday}
                            >
                              {day.is_holiday
                                ? "Hari Libur"
                                : "Jadikan Hari Libur"}
                            </Button>
                          </DialogTrigger>
                          <DialogContent>
                            <DialogHeader>
                              <DialogTitle>Jadikan Hari Libur</DialogTitle>
                              <DialogDescription>
                                Anda akan mengubah hari {day.day} menjadi hari
                                libur
                              </DialogDescription>
                            </DialogHeader>
                            <div className="grid w-full items-center gap-1.5">
                              <Label htmlFor="email">Nama Hari Libur</Label>
                              <Input
                                placeholder="Masukkan nama hari libur"
                                value={holidayName}
                                onChange={(e) => setHolidayName(e.target.value)}
                              />
                            </div>
                            <DialogFooter className="flex items-center gap-2 sm:gap-1 flex-c">
                              <DialogClose asChild>
                                <Button
                                  className="flex flex-1 w-full bg-card"
                                  variant="outline"
                                >
                                  Batal
                                </Button>
                              </DialogClose>
                              <DialogClose asChild>
                                <Button
                                  className="flex flex-1 w-full"
                                  onClick={() => {
                                    setZones((prevZones) =>
                                      prevZones.map((prevZonesDay) =>
                                        prevZonesDay.day === day.day
                                          ? {
                                              ...prevZonesDay,
                                              is_holiday: true,
                                              holidayName: holidayName,
                                              dropZones:
                                                prevZonesDay.dropZones.map(
                                                  (zone) => ({
                                                    ...zone,
                                                    allowedDay: false,
                                                  }),
                                                ),
                                            }
                                          : prevZonesDay,
                                      ),
                                    );
                                    handleHolidayNameSubmit(
                                      day.day,
                                      weekDates[index],
                                      holidayName,
                                    );
                                    setHolidayName("");
                                  }}
                                >
                                  Simpan
                                </Button>
                              </DialogClose>
                            </DialogFooter>
                          </DialogContent>
                        </Dialog>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}

                    {/* Mobile Dropzones */}
                    <div className="flex lg:hidden flex-col justify-center gap-2 h-full">
                      {day.dropZones.every((zone) => zone.allowedDay) ? (
                        day.dropZones.map((zone) => (
                          <Card
                            className={cn(
                              "flex h-20 hover:cursor-pointer items-center w-full transition-all hover:shadow-md",
                              roleId !== 5 && "pointer-events-none opacity-50", // 👈 disables interaction & dims
                              !zone.item &&
                                ! draftData[localDateString(weekDates[index])] &&
                                "border-2 border-dashed bg-merah-hover/5 border-merah-hover hover:border-solid hover:bg-merah-hover/20 transition-all text-merah-hover",
                              !zone.item &&
                                 draftData[localDateString(weekDates[index])] &&
                                "bg-merah-no/10 border-2 border-merah-no/20 text-merah-no hover:cursor-not-allowed",
                            )}
                            key={zone.id}
                            onClick={() => {
                              if (
                                roleId === 5 && // ✅ add this guard
                                zone.allowedDay &&
                                !purchaseOrder[localDateString(weekDates[index])]  &&
                                ! draftData[localDateString(weekDates[index])]
                              ) {
                                setSelectedZoneId(zone.id);
                                setSelectedCategory(zone.content);
                                setSelectedWeekDatesIndex(weekDates[index]);
                                setSearchQuery("");
                                setShowMenuDialog(true);
                              }
                            }}
                            disabled={roleId !== 5}
                          >
                            <div className="w-full text-center">
                              {zone.allowedDay ? (
                                zone.item ? (
                                  <div className="flex flex-col gap-0">
                                    <span className="font-medium">
                                      {zone.item.dish_name}
                                    </span>
                                    <span className="text-sm font-light text-gray-500">
                                      {zone.content}
                                    </span>
                                  </div>
                                ) : ! draftData[localDateString(weekDates[index])] ? (
                                  !purchaseOrder[localDateString(weekDates[index])]  ? (
                                    <div className="flex items-center justify-center text-merah-hover font-medium gap-3">
                                      <Plus size={16} /> {zone.content}
                                    </div>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  <div className="flex flex-col gap-1">
                                    <span className="font-medium">
                                      Tidak Terisi
                                    </span>
                                    <span className="text-sm font-light">
                                      {zone.content}
                                    </span>
                                  </div>
                                )
                              ) : (
                                ""
                              )}
                            </div>
                          </Card>
                        ))
                      ) : (
                        <Card className="flex min-h-[27rem] flex-col gap-0.5 text-pretty text-center px-12 items-center justify-center hover:cursor-not-allowed w-full border-2 border-dashed bg-merah-hover/5 border-merah-hover text-merah-hover">
                          <span className="font-semibold text-xl">
                            Hari Libur
                          </span>
                          <span>{day.holiday_name}</span>
                        </Card>
                      )}
                    </div>

            {roleId === 5 && !allDaysHoliday ? (
              <div className="flex pt-5 w-full justify-center">
                <Button
                  type="button"
                  onClick={() => handleSimpanMenu(localDateString(weekDates[index]))}

                  className="text-center mb-2"
                  disabled={
                    isDayDraftDisabled(day) || //  👈 per-day disable
                     draftData[localDateString(weekDates[index])] ||
                    purchaseOrder[localDateString(weekDates[index])]  ||
                    allDaysHoliday
                  }
                  title={
                    isDayDraftDisabled(day)
                      ? "Isi semua menu (kecuali Minuman) untuk hari ini"
                      : undefined
                  }
                >
                  {isDayDraftDisabled(day)
                    ? "Mohon isi menu"
                    :  draftData[localDateString(weekDates[index])]
                      ? purchaseOrder[localDateString(weekDates[index])]  
                        ? "Sudah Melakukan Pembelian"
                        : "Sudah Draft Pembelian"
                      : "Simpan"}
                </Button>
              </div>
            ) : (
              ""
            )}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <Button
              variant="outline"
              size="icon"
              className="lg:hidden absolute top-1/2 right-2 z-[2] translate-x-1/2 swiper-next my-auto"
            >
              <ChevronRight size={16} />
            </Button>
          </div>

          {/* Desktop Zones */}
          <div className="hidden lg:flex flex-col w-full lg:flex-row flex-wrap gap-3 justify-between">
            {zones.map((day, index) => (
              <div
                key={day.day}
                className={`flex-1 flex-col bg-[#F1F2F3] gap-4 items-center ${editingHolidayDay === day.day ? "w-full" : "w-full lg:w-1/5"}`}
              >
                <Card
                  className={cn(
                    "mb-4",
                    roleId === 3 && ! draftData[localDateString(weekDates[index])] ? "min-h-48" : "min-h-40",
                    day.is_holiday
                      ? "bg-primary"
                      : "bg-[#FFA101]/15 border-[#FFA101]/25",
                  )}
                >
                  <CardContent className="p-6 space-y-1">
                    <h2
                      className={cn(
                        "text-xl font-semibold text-primary-foreground",
                        !day.is_holiday && "text-foreground",
                      )}
                    >
                      {day.day}
                    </h2>
                    <div className="flex flex-col items-start justify-start gap-2 text-sm">
                      <p
                        className={
                          day.is_holiday
                            ? "text-primary-foreground"
                            : "text-gray-600"
                        }
                      >
                        {weekDates[index].toLocaleDateString("id-ID", {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        })}
                      </p>
                      <div className="flex flex-col gap-2 w-full">
                        <div
                          onClick={() =>
                            setExpandedDay(
                              expandedDay === day.day ? null : day.day,
                            )
                          }
                          className={cn(
                            "flex flex-col items-center gap-2 w-full overflow-hidden",
                            expandedDay === day.day
                              ? "overflow-visible text-wrap"
                              : "truncate overflow-hidden",
                            day.is_holiday
                              ? "text-primary-foreground"
                              : "text-gray-600",
                          )}
                        >
                          {day.is_holiday && (
                            <span className="whitespace-nowrap overflow-hidden text-pretty line-clamp-1 w-full">
                              {day.holiday_name || "Libur"}
                            </span>
                          )}
                          <div className="flex items-center gap-2 w-full">
                            {!day.is_holiday ? (
                              roleId === 3 || roleId === 5 ? (
                                <input
                                  value={formatNumber(day.pack) || ""}
                                  placeholder=" "
                                  className={`flex-1 bg-transparent w-full outline-none rounded-lg text-black text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-sm text-center flex-grow 
                                    ${roleId !== 3 ? "border-none" :  draftData[localDateString(weekDates[index])] ? "border-solid border-black bg-green-100" : "border-solid border-black bg-white"}`}
                                  onChange={(e) => {
                                    //  const newPackValue = formatNumber(e.target.value);
                                    const rawValue = e.target.value.replace(
                                      /\D/g,
                                      "",
                                    );

                                    setZones((prevZones) =>
                                      prevZones.map((zone) =>
                                        zone.day === day.day
                                          ? { ...zone, pack: rawValue }
                                          : zone,
                                      ),
                                    );
                                  }}
                                  disabled={
                                    roleId !== 3 || roleId !== 5 || draftData
                                  }
                                />
                              ) : (
                                formatNumber(day.pack) || ""
                              )
                            ) : (
                              ""
                            )}
                            {!day.is_holiday ? <span>Porsi</span> : ""}
                          </div>
                        </div>
                        <div className="flex items-center gap-2">

                          {/* Save Button */}
                          {/* {(roleId === 3 || roleId === 5) &&
                          !day.is_holiday &&
                          !draftData[localDateString(weekDates[index])] ? (
                            <button
                              onClick={() =>
                                handlePackChange(
                                  localDateString(weekDates[index]),
                                  day.pack,
                                )
                              }
                              disabled={
                                !day.pack || day.pack === "0" ||  draftData[localDateString(weekDates[index])]
                              } // Corrected condition
                              className={`rounded-lg  bg-transparent text-red-600 font-medium transition ${
                                loading
                                  ? "bg-gray-400 cursor-not-allowed"
                                  : !day.pack || day.pack === "0"
                                    ? "bg-gray-300 cursor-not-allowed"
                                    : "hover:text-green-600"
                              }`}
                            >
                              <span title="Simpans">
                                <ArrowDownIcon className="w-8 h-8" />
                              </span>
                            </button>
                          ) : (
                            ""
                          )} */}

                          {(roleId === 3 || roleId === 5) &&
                          !day.is_holiday &&
                          ! draftData[localDateString(weekDates[index])] ? (
                            <button
                              onClick={() =>
                                handleSchedule(
                                  localDateString(weekDates[index]),
                                  day.pack,
                                )
                              }
                              disabled={
                                !day.pack || day.pack === "0" ||  draftData[localDateString(weekDates[index])]
                              } // Corrected condition
                              className={` text-red-600 font-medium transition ${
                                loading
                                  ? "bg-gray-400 cursor-not-allowed"
                                  : !day.pack || day.pack === "0"
                                    ? "bg-gray-300 cursor-not-allowed"
                                    : "hover:text-green-600"
                              }`}
                            >
                              
                                <span className="flex items-center gap-2" title="Edit">
                                  <ListBullet className="w-8 h-8" />
                                  <p>Rencana Produksi</p>
                                </span>
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* "Set as Holiday" Button */}
                {! draftData[localDateString(weekDates[index])] ? (
                  !purchaseOrder[localDateString(weekDates[index])]  ? (
                    <Dialog>
                      <DialogTrigger asChild>
                        <Button
                          className="w-full text-center mb-2"
                          disabled={day.is_holiday}
                        >
                          {day.is_holiday ? "Hari Libur" : "Jadikan Hari Libur"}
                        </Button>
                      </DialogTrigger>
                      <DialogContent>
                        <DialogHeader>
                          <DialogTitle>Jadikan Hari Libur</DialogTitle>
                          <DialogDescription>
                            Anda akan mengubah hari {day.day} menjadi hari libur
                          </DialogDescription>
                        </DialogHeader>
                        <div className="grid w-full items-center gap-1.5">
                          <Label htmlFor="holidayName">Nama Hari Libur</Label>
                          <Input
                            placeholder="Masukkan nama hari libur"
                            value={holidayName}
                            onChange={(e) => setHolidayName(e.target.value)}
                          />
                        </div>
                        <DialogFooter className="flex items-center gap-2 sm:gap-1 flex-row">
                          <DialogClose asChild>
                            <Button
                              className="flex flex-1 w-full bg-card"
                              variant="outline"
                            >
                              Batal
                            </Button>
                          </DialogClose>
                          <DialogClose asChild>
                            <Button
                              className="flex flex-1 w-full"
                              onClick={() => {
                                setZones((prevZones) =>
                                  prevZones.map((prevZonesDay) =>
                                    prevZonesDay.day === day.day
                                      ? {
                                          ...prevZonesDay,
                                          is_holiday: true,
                                          holidayName: holidayName,
                                          dropZones: prevZonesDay.dropZones.map(
                                            (zone) => ({
                                              ...zone,
                                              allowedDay: false,
                                            }),
                                          ),
                                        }
                                      : prevZonesDay,
                                  ),
                                );
                                handleHolidayNameSubmit(
                                  day.day,
                                  weekDates[index],
                                  holidayName,
                                );
                                setHolidayName("");
                              }}
                            >
                              Simpan
                            </Button>
                          </DialogClose>
                        </DialogFooter>
                      </DialogContent>
                    </Dialog>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                {/* <div className="flex flex-col justify-between gap-4"> */}
                <div className="hidden lg:flex flex-col justify-start gap-2">
                  {day.dropZones.every((zone) => zone.allowedDay) ? (
                    day.dropZones.map((zone) => (
                      <Card
                        className={cn(
                          "flex h-20 hover:cursor-pointer items-center w-full transition-all hover:shadow-md",
                          roleId !== 5 && "pointer-events-none opacity-50", // 👈 disables interaction & dims
                          !zone.item &&
                            ! draftData[localDateString(weekDates[index])] &&
                            "border-2 border-dashed bg-merah-hover/5 border-merah-hover hover:border-solid hover:bg-merah-hover/20 transition-all text-merah-hover",
                          !zone.item &&
                             draftData[localDateString(weekDates[index])] &&
                            "bg-merah-no/10 border-2 border-merah-no/20 text-merah-no hover:cursor-not-allowed",
                        )}
                        key={zone.id}
                        onClick={() => {
                          if (
                            roleId === 5 && // ✅ add this guard
                            zone.allowedDay &&
                            !purchaseOrder[localDateString(weekDates[index])]  &&
                            ! draftData[localDateString(weekDates[index])]
                          ) {
                            setSearchQuery("");
                            setSelectedZoneId(zone.id);
                            setSelectedCategory(zone.content);
                            setSelectedWeekDatesIndex(weekDates[index]);
                            filterItems("", zone.content);
                            setShowMenuDialog(true);
                          }
                        }}
                        onDragOver={handleDragOver}
                        onDrop={(e) => handleDrop(e, zone.id, weekDates[index])}
                        disabled={roleId !== 5}
                      >
                        <div className="w-full px-4">
                          {zone.allowedDay ? (
                            zone.item ? (
                              <div className="flex flex-col gap-0">
                              <div className="flex flex-row justify-between items-center">
                                <span className="font-medium">
                                  {zone.item.dish_name}
                                </span>
                    {/* {! draftData[localDateString(weekDates[index])] ? (
                      !purchaseOrder[localDateString(weekDates[index])]  ? (
                                  <DeleteIcon
  className="h-4 w-4 rotate-45 text-merah-no hover:text-merah-hover"
  onClick={(e) =>
    openConfirm(
      zone.allowedCategoryId,
      localDateString(weekDates[index]),
      zone.content,
      zone.item?.dish_name ?? "",
      day.pack || "",
      e
    )
  }
/>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )} */}

                              </div>
                                <span className="text-sm font-light text-gray-500">
                                  {zone.content}
                                </span>
                              </div>
                            ) : ! draftData[localDateString(weekDates[index])] ? (
                              !purchaseOrder[localDateString(weekDates[index])]  ? (
                                <div className="flex items-center justify-start text-merah-hover font-medium gap-3">
                                  <Plus size={16} /> {zone.content}
                                </div>
                              ) : (
                                ""
                              )
                            ) : (
                              <div className="flex flex-col gap-1">
                                <span className="font-medium">
                                  Tidak Terisi
                                </span>
                                <span className="text-sm font-light">
                                  {zone.content}
                                </span>
                              </div>
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      </Card>
                    ))
                  ) : (
                    <Card className="flex min-h-[27rem] flex-col gap-0.5 text-pretty text-center px-4 items-center justify-center hover:cursor-not-allowed w-full border-2 border-dashed bg-merah-hover/5 border-merah-hover text-merah-hover">
                      <span className="font-semibold text-lg">Hari Libur</span>
                      <span className="text-balance text-sm">
                        {day.holiday_name}
                      </span>
                    </Card>
                    
                  )}
                  
                        {/* <div>{localDateString(new Date(weekDates[index]))}</div> */}

            {roleId === 5 && !allDaysHoliday && !day.is_holiday ? (
              <div className="flex pt-5 w-full justify-center">
                <Button
                  type="button"
                  onClick={() => handleSimpanMenu(localDateString(weekDates[index]))}

                  className="text-center mb-2"
                  disabled={
                    isDayDraftDisabled(day) || //  👈 per-day disable
                     draftData[localDateString(weekDates[index])] ||
                    purchaseOrder[localDateString(weekDates[index])]  ||
                    allDaysHoliday
                  }
                  title={
                    isDayDraftDisabled(day)
                      ? "Isi semua menu (kecuali Minuman) untuk hari ini"
                      : undefined
                  }
                >
                  {isDayDraftDisabled(day)
                    ? "Mohon isi menu"
                    :  draftData[localDateString(weekDates[index])]
                      ? purchaseOrder[localDateString(weekDates[index])]  
                        ? "Sudah Melakukan Pembelian"
                        : "Sudah Draft Pembelian"
                      : "Simpan"}
                </Button>
              </div>
            ) : (
              ""
            )}
            
          {roleId === 4 && !allDaysHoliday ? (
            <div className="flex flex-1 justify-end pt-8">
              <button
                type="button"
                onClick={handleBuatPesanan}
                className={`flex w-1/5 px-8 py-4 text-white rounded-[50px] uppercase items-center justify-center cursor-pointer ${! draftData[localDateString(weekDates[index])] || purchaseOrder[localDateString(weekDates[index])]  || allDaysHoliday ? "bg-gray-400 cursor-not-allowed" : "bg-merah-no hover:bg-merah-hover"}`}
                disabled={! draftData[localDateString(weekDates[index])] || purchaseOrder[localDateString(weekDates[index])]  || allDaysHoliday}
              >
                {"Buat Pesanan"}
              </button>
            </div>
          ) : (
            ""
          )}

          {roleId === 3 && !allDaysHoliday && !day.is_holiday ? (
            <div className="flex flex-1 justify-end pt-8">
              <button
                type="button"
                onClick={handleLihatPesanan}
                className={`flex w-full px-8 py-4 text-white rounded-[50px] uppercase items-center justify-center cursor-pointer text-xxs md:text-xxs lg:text-base ${
                    isDayDraftDisabled(day) || //  👈 per-day disable
                    purchaseOrder[localDateString(weekDates[index])]  ||
                    allDaysHoliday
                   ? "bg-gray-400 cursor-not-allowed" : "bg-merah-no hover:bg-merah-hover"}`}
                disabled={
                    isDayDraftDisabled(day) || //  👈 per-day disable
                    purchaseOrder[localDateString(weekDates[index])]  ||
                    allDaysHoliday
                  } // ❌ Disable only "Buat Draft Pesanan", keep others
              >
                {"Lihat Pesanan"}
              </button>
            </div>
          ) : (
            ""
          )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {(roleId === 2 || roleId === 5)  ? (
        <div className="hidden lg:flex flex-col sticky top-0 z-0 w-[15vw] h-[92vh] bg-white bg-opacity-0 text-black shadow-lg">
          <div className="p-5 bg-white bg-opacity-0 space-y-4">
            <div className="relative">
              <MagnificationLogo className="size-5 text-gray-500 absolute top-1/2 left-2 -translate-y-1/2" />
              <Input
                type="text"
                placeholder="Cari Menu"
                value={searchQuery}
                onChange={handleSearch}
                className="pl-8"
              />
            </div>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((category) => (
                <Badge
                  key={category}
                  variant={
                    selectedCategory === category ? "default" : "outline"
                  }
                  className={cn(
                    "cursor-pointer capitalize justify-center",
                    !(selectedCategory === category) && "bg-white",
                  )}
                  onClick={() => {
                    setSelectedCategory(category);
                  }}
                >
                  {category}
                </Badge>
              ))}
            </div>
            <div className="flex flex-col gap-2 overflow-y-auto h-[73vh]">
              {searchResult.length > 0 ? (
                searchResult.map((item) => (
                  <div
                    key={item.id}
                    className="p-4 bg-white rounded-[15px] shadow-md cursor-grab"
                    draggable
                    onDragStart={(e) => handleDragStart(e, item)}
                  >
                    <h3 className="font-semibold">{item.dish_name}</h3>
                    <p className="text-sm text-gray-500">
                      {item.category_name}
                    </p>
                  </div>
                ))
              ) : suggestion ? (
                <Card className="flex flex-col gap-4 p-4 items-center text-center">
                  <div className="rounded-full p-4 bg-gray-100 w-fit">
                    <MagnificationLogo className="size-6 text-gray-500" />
                  </div>
                  <div className="flex flex-col gap-2 justify-center items-center">
                    <span className="font-medium">
                      Menu "{searchQuery}" tidak ditemukan.
                    </span>
                    <span className="text-sm text-gray-500">
                      Namun, menu ini ditemukan di kategori{" "}
                      <strong>{suggestion.category_name}</strong>.
                    </span>
                  </div>
                  <div className="flex flex-col gap-2">
                    <Button
                      variant="outline"
                      onClick={() =>
                        setSelectedCategory(suggestion.category_name)
                      }
                      className="break-words whitespace-normal"
                    >
                      Beralih ke kategori {suggestion.category_name}
                    </Button>
                    <Button
                      onClick={() => {
                        setNewMenuData((prev) => ({
                          ...prev,
                          name: searchQuery,
                        }));
                        setShowCreateMenuDialog(true);
                      }}
                    >
                      Buat Menu Baru
                    </Button>
                  </div>
                </Card>
              ) : (
                <Card className="flex flex-col gap-4 p-4 items-center text-center">
                  <div className="rounded-full p-4 bg-gray-100 w-fit">
                    <MagnificationLogo className="size-6 text-gray-500" />
                  </div>
                  <div className="flex flex-col gap-2 justify-center items-center text-center">
                    <span className="font-medium">
                      Menu "{searchQuery}" tidak ditemukan
                    </span>
                    <span className="text-sm text-gray-500">
                      Buat menu baru atau coba kata kunci lain.
                    </span>
                  </div>
                  <Button
                    className="w-full"
                    onClick={() => {
                      setNewMenuData((prev) => ({
                        ...prev,
                        name: searchQuery,
                      }));
                      setShowCreateMenuDialog(true);
                    }}
                  >
                    Buat Menu Baru
                  </Button>
                </Card>
              )}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
<Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
  <DialogContent>
    <DialogHeader>
      <DialogTitle>Konfirmasi</DialogTitle>
      <DialogDescription>
        Apakah Anda yakin ingin menghapus{" "}
        <span className="font-medium">{toDelete?.category}</span>{" "}
        <span className="font-medium">{toDelete?.dishName}</span> pada tanggal{" "}
        <span className="font-medium">{toDelete?.date}</span>?
        <span className="font-medium">{toDelete?.zoneId}</span>?
        <span className="font-medium">{toDelete?.zonePack}</span>?
      </DialogDescription>
    </DialogHeader>

    <DialogFooter>
      <button
        type="button"
        className="rounded px-4 py-2 bg-gray-200 hover:bg-gray-300"
        onClick={() => setConfirmOpen(false)}
      >
        Batal
      </button>
      <button
        type="button"
        className="rounded px-4 py-2 bg-merah-no text-white hover:bg-merah-hover"
        onClick={handleConfirmDelete}
      >
        Hapus
      </button>
    </DialogFooter>
  </DialogContent>
</Dialog>

    </div>
  );
}
